import HttpService from "./htttp.service";

class AreasService {
  getAreas = async (query, cancelToken) => {
    const endpoint = "areas";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createArea = async (payload) => {
    const endpoint = "areas";
    return await HttpService.post(endpoint, payload);
  };

  removeArea = async (id) => {
    const endpoint = "areas/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateArea = async (id, payload) => {
    const endpoint = "areas/" + id;
    return await HttpService.put(endpoint, payload);
  };
}

export default new AreasService();
